import { ColumnButton } from 'lib/components/ColumnButton';
import { OrderEditableData } from 'lib/model/objects/orderModel';
import { ResponseOrError } from 'lib/types/responses';
import React, { useState } from 'react';

type EditOrderButtonProps = {
  editData: OrderEditableData | null;
  onEditOrder: () => Promise<ResponseOrError<void>>;
  disabled?: boolean;
};

export function EditOrderButton({
  editData,
  onEditOrder,
  disabled
}: EditOrderButtonProps) {
  const [isStartingEdit, setIsStartingEdit] = useState(false);
  const canEdit = editData && Object.values(editData).some(ed => ed.canEdit);

  const handleEditOrder = async () => {
    setIsStartingEdit(true);
    const [editError] = await onEditOrder();
    if (editError) {
      setIsStartingEdit(false);
    }
  };

  return (
    <ColumnButton
      id="edit-order-button"
      type="button"
      onClick={handleEditOrder}
      buttonText={'Edit'}
      loading={isStartingEdit}
      disabled={disabled || !canEdit}
    />
  );
}
